import { DefaultState } from '@src/redux/types'

import { USER_SESSIONS, USER_SESSIONS_LOGOUT_ALL, USER_SESSION_LOGOUT } from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [USER_SESSIONS]: DefaultState<`${typeof API.USER_SESSIONS}`, 'get'>
  [USER_SESSION_LOGOUT]: DefaultState<`${typeof API.USER_SESSION_LOGOUT}{id}`, 'post'>
  [USER_SESSIONS_LOGOUT_ALL]: DefaultState<`${typeof API.USER_SESSIONS_LOGOUT_ALL}`, 'post'>
} = () => ({
  [USER_SESSIONS]: defaultState(),
  [USER_SESSION_LOGOUT]: defaultState(),
  [USER_SESSIONS_LOGOUT_ALL]: defaultState(),
})
